module.exports = __webpack_public_path__ + "static/img/cartoon.62d91689.png";